/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import React, {useState} from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button} from '@mui/material';
import CreateProductDialog from "../dialogs/CreateProductDialog";
import axios from "axios";

const ProductTable = ({ products, catid }) => {
    const [Opencreateproductdialog, setOpencreateproductdialog] = useState(false)
    return (
        <div >
            <CreateProductDialog  open={Opencreateproductdialog} setOpen={setOpencreateproductdialog} category={catid}/>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>АЙДИ</TableCell>
                        <TableCell>ЗАГОЛОВОК</TableCell>
                        <TableCell>ИЗОБРАЖЕНИЕ</TableCell>
                        <TableCell>ВЕС</TableCell>
                        <TableCell>ОПИСАНИЕ</TableCell>
                        <TableCell>ЦЕНА</TableCell>
                        <TableCell>ДЕЙСТВИЯ</TableCell>
                    <TableCell><Button onClick={()=>{setOpencreateproductdialog(true)}}>ДОБАВИТЬ</Button></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.map((product) => (
                        <TableRow key={product.id}>
                            <TableCell>{product.id}</TableCell>
                            <TableCell>{product.title}</TableCell>
                            <TableCell>
                                <img src={`http://localhost:8083/photo/JPEG/${product.img}`} alt={product.title} width={50} height={50} />
                            </TableCell>
                            <TableCell>{product.weight}</TableCell>
                            <TableCell>{product.subscription}</TableCell>
                            <TableCell>{product.price}</TableCell>
                            <TableCell><Button onClick={()=>{
                                DeleteProduct(product.id)
                                alert("Удалено, обновите страницу")
                            }} variant="contained" color='error'>УДАЛИТЬ</Button></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </div>
    );
};

const DeleteProduct = (id) => {
  axios.delete(`https://kudiyarapi.gigagile.space/products?id=${id}`, {
          headers : {
              "Content-Type": "application/json",
              "Access-Control-Allow-Credentials": "*"
          }
      }
  ).then((response)=> {
      return true;
  })
}
export default ProductTable